import React from "react";
import { Alert, Typography } from "@mui/material";
import {
  mealOptionRowLabels,
  rowsMissingMealOption,
  type MealOptionRow,
} from "../utils/methods/mealOptionWarnings";

type MealOptionNoticeProps = {
  rows?: MealOptionRow[] | null;
  recordedBreakOnly?: boolean;
  compact?: boolean;
};

/** A reminder, never a confirmation step or a condition for saving/sending. */
export default function MealOptionNotice({
  rows,
  recordedBreakOnly = false,
  compact = false,
}: MealOptionNoticeProps) {
  const affected = rowsMissingMealOption(rows, recordedBreakOnly);
  if (!affected.length) return null;
  const labels = compact ? [] : mealOptionRowLabels(affected);

  return (
    <Alert severity="warning" variant="outlined" sx={{
      my: 1,
      textAlign: "left",
      color: "#f3d27a",
      bgcolor: "rgba(255,193,7,0.1)",
      borderColor: "rgba(255,193,7,0.5)",
      "& .MuiAlert-icon": { color: "#f3d27a" },
    }}>
      <Typography component="div" sx={{ fontSize: 13, color: "inherit" }}>
        {recordedBreakOnly
          ? "A break is recorded, but no meal option is selected."
          : "No meal option selected. Review the planned meal arrangements."}
        {" "}For crew pay, recorded meals under 1 hour stay paid; meals of 1 hour or longer are deducted unless staff mark the meal as Paid.
        {" "}Meal options still apply to client billing and planned estimates. You can continue.
      </Typography>
      {labels.length > 0 && (
        <Typography component="div" sx={{ fontSize: 12, color: "inherit", mt: 0.5 }}>
          {labels.slice(0, 4).join("; ")}
          {labels.length > 4 ? ` (+${labels.length - 4} more)` : ""}
        </Typography>
      )}
    </Alert>
  );
}
